"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LroImpl = void 0;
class LroImpl {
    sendOperationFn;
    args;
    spec;
    requestPath;
    requestMethod;
    constructor(sendOperationFn, args, spec, requestPath = spec.path, requestMethod = spec.httpMethod) {
        this.sendOperationFn = sendOperationFn;
        this.args = args;
        this.spec = spec;
        this.requestPath = requestPath;
        this.requestMethod = requestMethod;
    }
    async sendInitialRequest() {
        return this.sendOperationFn(this.args, this.spec);
    }
    async sendPollRequest(path) {
        const { requestBody, ...restSpec } = this.spec;
        return this.sendOperationFn(this.args, {
            ...restSpec,
            path,
            httpMethod: "GET"
        });
    }
}
exports.LroImpl = LroImpl;
//# sourceMappingURL=lroImpl.js.map